export const MENTAL_NOISE_GUIDE = {
  path: "/mental-noise",
  url: "https://ahavibes.xyz/mental-noise",
  headline:
    "The Complete Guide to Mental Noise: Understanding the Hidden Conversations That Shape Your Decisions",
  description:
    "Learn what mental noise is, where it comes from, how it affects anxiety and sleep, and practical techniques to reduce it for clearer thinking.",
  sections: [
    {
      id: "what-is-mental-noise",
      position: 1,
      name: "What Is Mental Noise?",
      description: "Definition and common patterns of internal dialogue.",
    },
    {
      id: "sources-of-mental-noise",
      position: 2,
      name: "Sources of Mental Noise",
      description:
        "Past experiences, stress, uncertainty, fear of judgment, and unexamined interpretations.",
    },
    {
      id: "internal-vs-external",
      position: 3,
      name: "Internal vs. External Mental Noise",
      description:
        "How environmental and self-generated noise differ and interact.",
    },
    {
      id: "mental-noise-vs-overthinking",
      position: 4,
      name: "Mental Noise vs. Overthinking",
      description:
        "How background mental noise differs from focused overthinking.",
    },
    {
      id: "mental-noise-and-anxiety",
      position: 5,
      name: "Mental Noise and Anxiety",
      description:
        "The loop between mental noise and anxious predictions.",
    },
    {
      id: "why-your-brain-wont-let-go",
      position: 6,
      name: "Why Your Brain Won't Let Go",
      description:
        "Why the brain replays stories and seeks certainty through familiar patterns.",
    },
    {
      id: "mental-noise-before-sleep",
      position: 7,
      name: "Mental Noise Before Sleep",
      description:
        "Why mental noise intensifies at night and how to manage it.",
    },
    {
      id: "reducing-mental-noise",
      position: 8,
      name: "Reducing Mental Noise",
      description:
        "Practical techniques including observing thoughts before believing them, structured thinking, and the Ahavibes perspective.",
    },
  ],
};
